import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useFormContext } from 'react-hook-form';

type AddCourseControlsProps = {
  handleSubmit: () => void;
  edit?: boolean;
};

export const AddCourseControls = ({ handleSubmit, edit }: AddCourseControlsProps) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();
  return (
    <div className={cn('flex w-full justify-end gap-2', 'ea-add-course-controls')}>
      <Button
        type="button"
        className="w-full md:w-auto"
        disabled={isSubmitting}
        onClick={() => handleSubmit()}
      >
        {edit ? 'Upraviť vzdelávací kurz' : 'Vytvoriť vzdelávací kurz'}
      </Button>
    </div>
  );
};
